"use client"

import type { BlockchainFilter } from "@/app/blockchains/filters/blockchain-filters-scope"
import { DropsNavigation } from "@/app/collections/drops/view/navigation"

interface Props {
  blockchain?: BlockchainFilter
}

export function Header({ blockchain }: Props) {
  return (
    <div
      className="width-full flex flex-shrink-0 flex-wrap items-center justify-between gap-4 px-0 md:px-4"
      data-testid="drops-header"
    >
      <DropsNavigation blockchain={blockchain} />
    </div>
  )
}
